import {
  channelRenderHelper,
  countryRenderHelper,
} from '@op/pages/download/renderHelper';
import { DownloadConfigInfoType } from '@op/pages/download/types';
import { getHashtagDetailsVideoList, getHashtagTableList } from '@opm/services';

const headerMap: any = {
  rank: '(by Hot)',
  tweets_views: '(by Views)',
  tweets_posts: '(by Videos)',
};

export const MarketingHashtagTableDownload: DownloadConfigInfoType = {
  type: 'page',
  downloadFunc: params => {
    return getHashtagTableList({ data: params });
  },
  columns: ({ filter }) => {
    const { sort_item } = filter;

    return [
      { key: 'rank', header: `Rank (${headerMap[sort_item]})` },
      { key: 'hashtag', header: 'Hashtags' },
      { key: 'tweets_posts', header: 'Videos' },
      { key: 'tweets_views', header: 'Views' },
      { key: 'category', header: 'Category' },
    ];
  },
};

export const HashtagTrendDownload: DownloadConfigInfoType = {
  columns: () => {
    return [
      { key: 'time', header: 'Date' },
      { key: 'tweets_posts', header: 'Tiktok Videos' },
      { key: 'tweets_views', header: 'Tiktok Views' },
    ];
  },
};

export const HashtagVideoDownload: DownloadConfigInfoType = {
  type: 'page',
  downloadFunc: params => {
    return getHashtagDetailsVideoList({ data: params });
  },
  columns: () => {
    return [
      { key: 'video_title', header: 'Video Title(Origin)' },
      { key: 'video_title_en', header: 'Video Title(English)' },
      { key: 'video_title_zh', header: 'Video Title(Chinese)' },
      { key: 'anchor_name', header: 'Author' },
      {
        key: 'channel_name',
        header: 'Channel',
        renderHelper: [channelRenderHelper],
      },
      { key: 'video_release_time', header: 'Release Time' },
      {
        key: 'country',
        header: 'Country',
        renderHelper: [countryRenderHelper],
      },
      { key: 'tweets_view', header: 'Views' },
      { key: 'engagement', header: 'Engagement' },
      { key: 'tweets_like', header: 'Likes' },
    ];
  },
};
